import BookingRequest from './booking-request';

export default BookingRequest;
